import { NullableString } from '@models/app.models';
import { createAction, props } from '@ngrx/store';
import { Station } from 'src/app/models/responses/station-response.model';

export const enum StationActionTypes {
  getActiveStationsWithMarketsSuccess = '[station] GET_ACTIVE_STATIONS_WITH_MARKETS_SUCCESS',
  stationGetActiveStationsWithConnectionMarketsSuccess = '[station] GET_ACTIVE_STATIONS_WITH_CONNECTION_MARKETS_SUCCESS',
  getAllStationAdvisory = '[station] GET_ALL_STATION_ADVISORY',
  getStationAdvisory = '[station] GET_STATION_ADVISORY',
  setStationAdvisory = '[station] SET_STATION_ADVISORY',
  setNearestStation = '[station] SET_NEAREST_STATION',
}

export const stationGetActiveStationsWithMarketsSuccess = createAction(
  StationActionTypes.getActiveStationsWithMarketsSuccess,
  props<{ payload: Station[] }>(),
);

export const stationGetActiveStationsWithConnectionMarketsSuccess =
  createAction(
    StationActionTypes.stationGetActiveStationsWithConnectionMarketsSuccess,
    props<{ payload: Station[] }>(),
  );

export const updateNearestStation = createAction(
  StationActionTypes.setNearestStation,
  props<{
    stationCode: NullableString;
  }>(),
);
